import shop from "@/api/orders";
import {
    authenticationService
} from '@/_services';
// initial state
const state = {
    all: [],
    city: [],
    hbGroup: [],
    Order: {},

    selectedOrders: [],
    hbStateItems: [{
        id: "",
        value: "Durum Seç"
    },
        {
            id: "InTransit",
            value: "Kargoda"
        },
        {
            id: "Packaged",
            value: "Paketlendi"
        },
        {
            id: "Delivered",
            value: "Teslim Edildi"
        },
        {
            id: "ClaimCreated",
            value: "Teslim Edilemedi"
        },
        {
            id: "CancelledByCustomer",
            value: "İptal"
        },
        {
            id: "Pending",
            value: "Onay Bekliyor"
        },
        {
            id: "OrderPreparing",
            value: "Tedarik Sürecinde"
        },
        {
            id: "Confirmed",
            value: "Onaylandı"
        },
        {
            id: "Refunded",
            value: "İade Edildi"
        },


    ],
    stateItems: [{
        id: 1,
        name: "Altında Fırsat",
        states: [{
            id: -1,
            value: "Durum Seç"
        },
            {
                id: 0,
                value: "Yeni Sipariş"
            },
            {
                id: 1,
                value: "Tedarik Sürecinde"
            },
            {
                id: 2,
                value: "Kargo Gönderildi"
            },
            {
                id: 3,
                value: "İptal Edildi"
            },
            {
                id: 4,
                value: "İade Verildi"
            },
            {
                id: 5,
                value: "Havale Bekleniyor"
            },
            {
                id: 6,
                value: "Teslim Edildi"
            }
        ]
    },
        {
            id: 2,
            name: "E-Altın",
            states: [{
                id: -1,
                value: "Durum Seç"
            },
                {
                    id: 0,
                    value: "Yeni Sipariş"
                },
                {
                    id: 1,
                    value: "Tedarik Sürecinde"
                },
                {
                    id: 2,
                    value: "Havale Gönderildi"
                },
                {
                    id: 3,
                    value: "İptal Edildi"
                },
                {
                    id: 4,
                    value: "İade Verildi"
                }
            ]
        }
    ],
    uyumStates: [{
        id: 0,
        value: "Eşleşmedi"
    },
        {
            id: 1,
            value: "Gönderilmedi"
        },
        {
            id: 2,
            value: "Taslak"
        },
        {
            id: 3,
            value: "İptal Edildi"
        },
        {
            id: 4,
            value: "Kuyrukta"
        },
        {
            id: 5,
            value: "İşleniyor"
        },
        {
            id: 6,
            value: "Gib'e gönderildi"
        },
        {
            id: 7,
            value: "Aktarıldı"
        },
        {
            id: 8,
            value: "Onay Bekleniyor"
        },
        {
            id: 9,
            value: "Reddedildi"
        },
        {
            id: 10,
            value: "Return"
        },
        {
            id: 11,
            value: "E-Arşiv İptal Edildi"
        },
        {
            id: 12,
            value: "Hata"
        }
    ]
};
// getters
const getters = {
    Order: state => {
        return state.Order;
    },
    getStateItems: state => {
        return state.stateItems.find(el => el.id == authenticationService.currentUserValue.tenantId).states;
    },
    getHbStateItems: state => {
        return state.hbStateItems;
    },

};

// actions
const actions = {
    getAllOrders({
                     commit
                 }) {
        shop.getOrders().then(Orders => {
            commit("getOrders", Orders.data);
        });
    },
    hbStatusGroup: async (context, Order) => {
        let d = (await shop.hbStatusGroup(Order)).data;
        context.commit("getHbStatusGroup", d);
        return d;
    },
    searchOrder: async (context, Order) => {
        let d = (await shop.searchOrder(Order)).data;
        context.commit("getOrders", d);
        return d;
    },
    getReturnedOrders: async (_context, payload) => {
        const p = payload || {};
        const d = (await shop.getReturnedOrders(p.startDate, p.endDate)).data;
        return d || [];
    },
    getPendingShipments: async (_context, payload) => {
        const p = payload || {};
        const d = (await shop.getPendingShipments(p.startDate, p.endDate)).data;
        return d || { totalGram: 0, totalQuantity: 0, productCount: 0, items: [] };
    },
    cancelInvoice: async (_context, id) => {
        const d = (await shop.cancelInvoice(id)).data;
        return d || { success: false, message: 'Bilinmeyen hata.' };
    },
    getLostOrders: async (_context, payload) => {
        const p = payload || {};
        const d = (await shop.getLostOrders(p.startDate, p.endDate)).data;
        return d || [];
    },
    getInsuranceFees: async (_context, payload) => {
        const p = payload || {};
        const d = (await shop.getInsuranceFees(p.startDate, p.endDate, p.onlyLost)).data;
        return d || { totalPayable: 0, totalReceivable: 0, net: 0, items: [] };
    },
    markOrderLost: async (_context, payload) => {
        const p = payload || {};
        const d = (await shop.markOrderLost(p.id, p.isLost)).data;
        return d || { success: false, message: 'Bilinmeyen hata.' };
    },
    getOrder: async (context, id) => {
        let d = (await shop.getOrder(id)).data;
        context.commit("getOrder", d);
        return d;
    },
    getCity: async (context, id) => {
        let d = (await shop.getCity(id)).data;
        context.commit("getCity", d);
        return d;
    },
    postOrder: async (context, Order) => {
        const result = (await shop.postOrder(Order)).data;
        context.commit("postOrder", result);
    },
    putOrder: async (context, Order) => {
        const result = (await shop.putOrder(Order)).data;
        context.commit("putOrder", result);
    },
    deleteOrder: async (context, Order) => {
        const result = (await shop.deleteOrder(Order)).data;
        // eslint-disable-next-line no-console
        console.log(result);
        context.commit("deleteOrder", Order);
    },
    bulkUpdateStates: async (context, model) => {
        const result = (await shop.bulkUpdateStates(model)).data;
        // eslint-disable-next-line no-console
        context.commit("bulkUpdateStates", model);
    },
    saveInsurance: async (context, model) => {
        const result = (await shop.saveInsurance(model)).data;
    },
    uploadInsurance: async (context, model) => {
        return (await shop.uploadInsurance(model)).data;
    },
    reSendInvoice: async (context, model) => {
        const result = (await shop.reSendInvoice(model)).data;
        // // eslint-disable-next-line no-console
        // context.commit("reSendInvoice", model);
    }
};

// mutations
const mutations = {
    getOrders(state, Orders) {
        state.all = Orders;
    },
    getCity(state, Orders) {
        state.city = Orders;
    },
    getHbStatusGroup(state, Orders) {
        state.hbGroup = Orders;
    },

    setSelectedOrders(state, Orders) {
        state.selectedOrders = Orders;
    },
    getOrder(state, Order) {
        //state.Order = Order
        state.Order = null;
        state.Order = Object.assign({}, state.Order, Order);
    },
    postOrder(state, Order) {
        //state.Order = Order
        state.Order = null;
        state.Order = Object.assign({}, state.Order, Order);
    },
    putOrder(state, Order) {
        //state.Order = Order
        state.Order = null;
        state.Order = Object.assign({}, state.Order, Order);
    },
    deleteOrder(state, Order) {
        state.all.splice(state.all.indexOf(Order), 1);
    },
    bulkUpdateStates(state, model) {
        // const data = model.selecteItems.map(({ id }) => id);
        model.selectedItems.map(item => {
            item.state = model.stateId;
            return item;
        })
        console.log(model.selectedItems);
        state.all = Object.assign({}, state.all, model.selectedItems);

        // state.all.splice(state.all.indexOf(Order), 1);
    },
    decrementOrderInventory(state, {
        id
    }) {
        const Order = state.all.find(Order => Order.id === id);
        Order.inventory--;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};